<template>
    <MainLayout>
        <div :class="theme === 'dark' ? 'tw-bg-[#151515] tw-text-gray-100' : 'tw-bg-gray-100 tw-text-gray-800'" class="tw-flex tw-h-screen tw-max-h-screen tw-overflow-hidden theme-container" :data-theme="theme">
            <main class="custom-scrollbar tw-flex-1 tw-p-6 tw-overflow-y-auto">
                <div class="tw-max-w-5xl tw-mx-auto">
                    <div class="tw-flex tw-justify-between tw-items-center tw-mb-4">
                        <div>
                            <h1 :class="theme === 'dark' ? 'tw-text-gray-100' : 'tw-text-gray-900'" class="tw-text-2xl tw-font-bold">Análise Inteligente de Armazenagem</h1>
                            <p :class="theme === 'dark' ? 'tw-text-gray-300' : 'tw-text-gray-600'">Gere novos relatórios ou consulte o histórico.</p>
                        </div>
                            <button 
                                v-if="(analiseSelecionada && analiseSelecionadaDados || isLoading)" 
                                @click="novaAnaliseForm"
                                :class="theme === 'dark' ? 'tw-bg-gray-800 hover:tw-bg-gray-700 tw-text-gray-200' : 'tw-bg-white hover:tw-bg-gray-100 tw-text-gray-800'" class="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-rounded-lg tw-shadow-sm"
                            >
                            <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-4 tw-w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                            </svg>
                            <span class="tw-text-sm tw-font-medium">Nova Análise</span>
                        </button>
                    </div>
                    <div>
                        <transition name="fade-slide" mode="out-in">
                            <div v-if="isLoading" class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-20 card-bg tw-rounded-xl tw-border tw-border-green-500/30">
                                <div class="tw-relative tw-mb-6">
                                    <div class="tw-w-16 tw-h-16 tw-border-4 tw-border-gray-700 tw-border-t-green-500 tw-rounded-full tw-animate-spin"></div>
                                    <div class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-text-xs tw-font-bold tw-text-green-500">
                                        {{ (loadingStep + 1) * 33 }}%
                                    </div>
                                </div>
                                <h3 class="tw-text-xl tw-font-semibold tw-text-gray-100 tw-mb-2">Processando Análise</h3>
                                <p class="tw-text-green-400 tw-animate-pulse">
                                    {{ loadingMessages[loadingStep] }}
                                </p>
                                
                                <div class="tw-w-64 tw-h-1.5 tw-bg-gray-800 tw-rounded-full tw-mt-6 tw-overflow-hidden">
                                    <div 
                                        class="tw-h-full tw-bg-green-500" 
                                        :style="{ width: (loadingStep + 1) * 33 + '%' }"
                                ></div>
                                </div>
                            </div>
                        </transition>

                        <div v-if="analiseSelecionada && analiseSelecionadaDados?.response?.relatorio" class="tw-flex tw-flex-col lg:tw-flex-row tw-gap-6 tw-items-start">
                            <div class="tw-flex-1 tw-bg-[#1a1d21] tw-text-gray-100 tw-p-8 tw-rounded-xl tw-shadow-2xl">
                                <h2 v-if="isAdmin" class="tw-text-l tw-mb-6">Gerado por {{ analiseSelecionadaDados.model }}</h2>
                                <div class="tw-flex tw-items-center tw-gap-3 tw-mb-6">
                                    <div class="tw-p-2 tw-bg-green-500/20 tw-rounded-lg">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-6 tw-w-6 tw-text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h2 class="tw-text-2xl tw-font-bold">Relatório Técnico de Armazenagem</h2>
                                        <p class="tw-text-sm tw-text-gray-400">
                                            {{analiseSelecionadaDados.silo_descricao}}
                                             • 
                                            {{analiseSelecionadaDados.produto}} 
                                            (em {{analiseSelecionadaDados.objetivo}})
                                        </p>
                                        <p class="tw-text-sm tw-text-gray-600">
                                           - Leitura utilizada: {{analiseSelecionadaDados.leitura_data}}
                                        </p>
                                    </div>
                                </div>

                                <div class="tw-bg-green-900/10 tw-border-l-4 tw-border-green-500 tw-p-4 tw-mb-8">
                                    <p class="tw-text-sm tw-leading-relaxed tw-text-gray-200 tw-text-justify">
                                        {{ analiseSelecionadaDados.response.relatorio.descricao_geral }}
                                    </p>
                                </div>

                                <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-8 tw-mb-8">
                                    <div>
                                        <h3 class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider tw-mb-4 tw-flex tw-items-center tw-gap-2">
                                            <span class="tw-text-orange-400">🌡️</span> <span :class="theme === 'dark' ? 'tw-text-gray-300' : 'tw-text-black'">Perfil Térmico Analítico</span>
                                        </h3>
                                        <div class="tw-flex tw-gap-4 tw-mb-4">
                                            <div class="tw-bg-black/20 tw-p-4 tw-rounded-lg tw-flex-1 tw-border-b-4 tw-border-green-500">
                                                <span class="tw-block tw-text-[10px] tw-text-gray-400 tw-uppercase">Média Atual</span>
                                                <span class="tw-text-2xl tw-font-bold tw-text-green-400">{{ parseFloat(analiseSelecionadaDados.response.relatorio.faixa_prod.atual).toFixed(1) }}°C</span>
                                            </div>
                                            <div class="tw-bg-black/20 tw-p-4 tw-rounded-lg tw-flex-1 tw-border-b-4 tw-border-gray-700">
                                                <span class="tw-block tw-text-[10px] tw-text-gray-400 tw-uppercase">Limite superior</span>
                                                <span class="tw-text-2xl tw-font-bold tw-text-gray-300">{{ analiseSelecionadaDados.response.relatorio.faixa_prod.max }}°C</span>
                                            </div>
                                        </div>
                                        
                                        <div class="tw-flex tw-justify-between tw-text-[10px] tw-mb-1 tw-text-gray-400">
                                    <span :class="theme === 'dark' ? 'tw-text-gray-300' : 'tw-text-black'">Faixa Ideal: {{ analiseSelecionadaDados.response.relatorio.faixa_prod.min }}°C - {{ analiseSelecionadaDados.response.relatorio.faixa_prod.max }}°C</span>
                                    
                                    <span :class="[statusTermico.cor, 'tw-font-bold tw-uppercase']">
                                        <span>Status: {{ statusTermico.texto }}</span>
                                    </span>
                                </div>

                                <div class="tw-h-1.5 tw-w-full tw-bg-gray-700 tw-rounded-full tw-overflow-hidden tw-flex">
                                    <div class="tw-h-1.5 tw-w-full tw-bg-gray-700 tw-rounded-full tw-overflow-hidden tw-flex">
                                        <div class="tw-h-full tw-bg-green-500" :style="{ width: ((analiseSelecionadaDados.response.relatorio.faixa_prod.atual / analiseSelecionadaDados.response.relatorio.faixa_prod.max) * 100) + '%' }"></div>
                                    </div>
                                </div>
                                    <p :class="theme === 'dark' ? 'tw-text-gray-300' : 'tw-text-black'" class="tw-mt-4 tw-text-xs tw-italic tw-text-justify">
                                        {{ analiseSelecionadaDados.response.relatorio.faixa_prod.desc }}
                                    </p>
                                    </div>
                                    <div>
                                        <h3 class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider tw-text-gray-500 tw-mb-4 tw-flex tw-items-center tw-gap-2">
                                            <span class="tw-text-green-400">⚠️</span> <span :class="theme === 'dark' ? 'tw-text-gray-300' : 'tw-text-black'">Probabilidades de Risco</span>
                                        </h3>
                                        <div v-for="risco in analiseSelecionadaDados.response.relatorio.riscos_qualidade" :key="risco.nome" class="tw-mb-4">
                                            <div class="tw-flex tw-justify-between tw-text-xs tw-mb-1">
                                                <span class="tw-text-gray-300">{{ risco.nome }}</span>
                                                <span class="tw-font-bold" :class="risco.probabilidade > 50 ? 'tw-text-orange-400' : 'tw-text-green-400'">{{ risco.probabilidade }}%</span>
                                            </div>
                                            <div class="tw-h-1.5 tw-w-full tw-bg-gray-700 tw-rounded-full tw-overflow-hidden">
                                                <div class="tw-h-full tw-bg-blue-500" :style="{ width: risco.probabilidade + '%' }"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="analiseSelecionadaDados.response.relatorio.cabos_com_defeito.length && cabosComDefeito.length" 
                                    class="tw-mb-8 tw-p-3 tw-bg-blue-900/10 tw-border tw-border-blue-900/30 tw-rounded-lg">
                                    
                                    <h4 :class="theme === 'dark' ? 'tw-text-blue-400' : 'tw-text-blue-900'" class="tw-text-[10px] tw-font-bold tw-uppercase tw-mb-2 tw-flex tw-items-center tw-gap-1 tw-d-flex">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-3 tw-w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                        Notas de Manutenção
                                    </h4>

                                    <div v-for="item in cabosComDefeito"
                                        :class="theme === 'dark' ? 'tw-text-gray-400' : 'tw-text-gray-900'"
                                        :key="item.cabo" 
                                        class="tw-text-xs">
                                        • Cabo {{ item.cabo }}: Sensores ({{ item.sensores_off.join(', ') }})
                                    </div>
                                </div>
                                <div v-if="analiseSelecionadaDados.response.relatorio.focos_de_calor.length && focosDeCalor.length" 
                                    class="tw-mb-8 tw-p-3 tw-bg-red-900/10 tw-border tw-border-red-900/30 tw-rounded-lg">
                                    
                                    <h4 :class="theme === 'dark' ? 'tw-text-red-400' : 'tw-text-red-900'" class="tw-text-[10px] tw-font-bold tw-uppercase tw-mb-2 tw-flex tw-items-center tw-gap-1 tw-d-flex">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-3 tw-w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                        Focos de calor
                                    </h4>

                                    <div v-for="item in focosDeCalor"
                                        :class="theme === 'dark' ? 'tw-text-gray-400' : 'tw-text-gray-900'"
                                        :key="item.cabo" 
                                        class="tw-text-xs">
                                        • Cabo {{ item.cabo }}: Sensores ({{ item.sensores_quentes.join(', ') }})
                                    </div>
                                </div>

                                <div class="tw-mt-8 tw-pt-6 tw-border-t tw-border-gray-800">
                                    <h3 class="tw-text-sm tw-font-bold tw-mb-2 tw-flex tw-items-center tw-gap-2">
                                        <span :class="theme === 'dark' ? 'tw-text-blue-400' : 'tw-text-blue-800'">Resumo Operacional</span>
                                    </h3>
                                    <p class="tw-text-sm tw-text-gray-300 tw-leading-relaxed tw-bg-black/10 tw-p-4 tw-rounded-lg tw-text-justify">
                                        {{ analiseSelecionadaDados.response.relatorio.resumo_geral }}
                                    </p>
                                </div>
                            </div>
                            <div>
                                <div class="tw-text-gray-100 tw-w-full lg:tw-w-80 tw-rounded-xl tw-p-6 tw-bg-[#1a1d21] tw-shadow-2xl">
                                    <div class="tw-flex tw-items-center tw-gap-2 tw-mb-4">
                                        <span class="tw-text-green-400 tw-text-xl">≡</span>
                                        <h2 class="tw-text-lg tw-font-bold">Plano de Aeração</h2>
                                    </div>
                                    <p class="tw-text-[11px] tw-text-gray-500 tw-mb-6 tw-uppercase tw-tracking-widest">Recomendação da IA</p>
                                    <div class="tw-grid tw-grid-cols-2 tw-gap-4 tw-mb-8">
                                        <div class="tw-bg-black/20 tw-p-4 tw-rounded-lg tw-text-center">
                                            <span class="tw-block tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase tw-mb-1">Temp. Alvo</span>
                                            <span class="tw-text-lg tw-font-bold tw-text-green-400">
                                                {{ analiseSelecionadaDados.response.relatorio.aeracao.parametros.temperatura_minima }}-{{ analiseSelecionadaDados.response.relatorio.aeracao.parametros.temperatura_maxima }}°C
                                            </span>
                                        </div>
                                        <div class="tw-bg-black/20 tw-p-4 tw-rounded-lg tw-text-center">
                                            <span class="tw-block tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase tw-mb-1">UR% Alvo</span>
                                            <span class="tw-text-lg tw-font-bold tw-text-green-400">
                                                {{ analiseSelecionadaDados.response.relatorio.aeracao.parametros.umidade_minima }}-{{ analiseSelecionadaDados.response.relatorio.aeracao.parametros.umidade_maxima }}%
                                            </span>
                                        </div>
                                    </div>

                                    <h3 class="tw-text-[10px] tw-font-bold tw-text-green-500 tw-uppercase tw-tracking-widest tw-mb-3 tw-flex tw-items-center tw-gap-2">
                                        <svg class="tw-h-3 tw-w-3" fill="currentColor" viewBox="0 0 24 24"><path d="M13 10V3L4 14h7v7l9-11h-7z"/></svg>
                                        Justificativa Técnica
                                    </h3>
                                    <p class="tw-text-xs tw-text-gray-400 tw-leading-relaxed tw-italic tw-border-l-2 tw-border-gray-700 tw-pl-3 tw-text-justify">
                                        "{{ analiseSelecionadaDados.response.relatorio.aeracao.justificativa }}"
                                    </p>

                                </div>
                                <button v-if="isAdmin"
                                    type="button"
                                    @click="excluirAnaliseSelecionada"
                                    :disabled="isDeletingAnalise"
                                    class="tw-mt-6 tw-w-full tw-py-2.5 tw-rounded-lg tw-border tw-border-red-500/50 tw-text-red-400 hover:tw-bg-red-500/10 disabled:tw-opacity-60 disabled:tw-cursor-not-allowed tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider"
                                >
                                    {{ isDeletingAnalise ? 'Excluindo...' : 'Excluir análise' }}
                                </button>
                            </div>
                        </div>
                        <div v-else-if="!isLoading" class="tw-flex tw-items-start tw-justify-center">
                            <div class="tw-w-full tw-max-w-3xl tw-text-gray-100 tw-rounded-lg tw-overflow-hidden">
                                <div class="tw-px-6 tw-py-5 tw-flex tw-items-center tw-gap-4">
                                    <div class="tw-bg-green-600 tw-rounded tw-p-2 tw-flex tw-items-center tw-justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-5 tw-w-5 tw-text-white" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M12 2 L15 9 L22 12 L15 15 L12 22 L9 15 L2 12 L9 9 Z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h3 class="tw-text-lg tw-font-semibold">Nova Análise Inteligente</h3>
                                        <p class="tw-text-sm tw-text-gray-400">Configure os parâmetros para analise do {{ selectedSilo && selectedSilo.nome ? selectedSilo.nome : 'silo' }}.</p>
                                    </div>
                                </div>
                                <div class="tw-p-6">
                                    <div class="tw-mb-6">
                                        <label class="tw-block tw-text-sm tw-text-gray-300 tw-mb-2">Local de Armazenagem</label>
                                        <div class="tw-relative">
                                            <select 
                                                v-model="selectedSilo"
                                                class="tw-custom-select tw-w-full"
                                            >
                                                <option :value="null">Selecione um local de armazenagem</option>
                                                <option 
                                                    v-for="silo in silosFiltered" 
                                                    :key="silo.id" 
                                                    :value="silo"
                                                >
                                                    {{ silo.nome }}
                                                </option>
                                            </select>
                                            <div class="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-3 tw-flex tw-items-center tw-text-gray-400">
                                                <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-4 tw-w-4" viewBox="0 0 20 20" fill="currentColor">
                                                    <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="tw-mb-6">
                                        <div class="tw-text-sm tw-text-gray-300 tw-mb-3">Qual o seu objetivo principal?</div>
                                        <div class="tw-flex tw-gap-3">
                                            <button type="button" @click="form.objetivo='secagem'" :class="tileClass('secagem')">
                                                <div class="tw-flex tw-items-start tw-gap-3">
                                                    <div class="tw-text-left">
                                                        <div class="tw-font-medium">Secagem</div>
                                                        <div class="tw-text-xs tw-text-gray-400">Remoção de umidade excedente</div>
                                                    </div>
                                                </div>
                                            </button>

                                            <button type="button" @click="form.objetivo='conservação'" :class="tileClass('conservação')">
                                                <div class="tw-flex tw-items-start tw-gap-3">
                                                    <div class="tw-text-left">
                                                        <div class="tw-font-medium">Conservação</div>
                                                        <div class="tw-text-xs tw-text-gray-400">Manutenção da qualidade estável</div>
                                                    </div>
                                                </div>
                                            </button>

                                            <button type="button" @click="form.objetivo='resfriamento'" :class="tileClass('resfriamento')">
                                                <div class="tw-flex tw-items-start tw-gap-3">
                                                    <div class="tw-text-left">
                                                        <div class="tw-font-medium">Resfriamento</div>
                                                        <div class="tw-text-xs tw-text-gray-400">Baixar massa térmica rapidamente</div>
                                                    </div>
                                                </div>
                                            </button>
                                        </div>
                                    </div>

                                    <div class="tw-mb-6">
                                        <label class="tw-block tw-text-sm tw-text-gray-300 tw-mb-2">Umidade do Grão (%)</label>
                                        <div class="tw-flex tw-items-center">
                                            <input 
                                                v-model="form.umidade" 
                                                type="number" 
                                                step="0.1" 
                                                class="tw-custom-input tw-w-40 tw-rounded-l"
                                                placeholder="Ex: 13.5"
                                            />
                                            <div class="tw-input-addon">%</div>
                                        </div>

                                        <p :class="theme === 'dark' ? 'tw-text-gray-300' : 'tw-text-gray-700'" class="tw-text-xs tw-mt-2">Campo opcional.</p>
                                    </div>

                                    <div v-if="isAdmin" class="tw-mb-8">
                                        <label class="tw-block tw-text-sm tw-text-gray-300 tw-mb-3">Inteligência Artificial</label>
                                        <div class="tw-flex tw-p-1 tw-rounded-lg tw-w-fit">
                                            <button 
                                                type="button" 
                                                @click="form.provider = 'gpt'"
                                                :class="[
                                                    'tw-px-4 tw-py-1.5 tw-rounded-md tw-text-sm tw-flex tw-items-center tw-gap-2',
                                                    form.provider === 'gpt' ? 'tw-bg-gray-500 tw-text-white tw-shadow-sm' : 'tw-text-gray-500 hover:tw-text-gray-300'
                                                ]"
                                            >
                                                <span class="tw-w-2 tw-h-2 tw-rounded-full" :class="form.provider === 'gpt' ? 'tw-bg-green-400' : 'tw-bg-gray-600'"></span>
                                                GPT
                                            </button>
                                            <button 
                                                type="button" 
                                                @click="form.provider = 'gemini'"
                                                :class="[
                                                    'tw-px-4 tw-py-1.5 tw-rounded-md tw-text-sm tw-flex tw-items-center tw-gap-2',
                                                    form.provider === 'gemini' ? 'tw-bg-gray-500 tw-text-white tw-shadow-sm' : 'tw-text-gray-500 hover:tw-text-gray-300'
                                                ]"
                                            >
                                                <span class="tw-w-2 tw-h-2 tw-rounded-full" :class="form.provider === 'gemini' ? 'tw-bg-blue-400' : 'tw-bg-gray-600'"></span>
                                                Gemini
                                            </button>
                                        </div>
                                    </div>
                                        <div class="tw-flex tw-justify-center">
                                        <button @click="gerarAnalise" class="tw-bg-green-600 hover:tw-bg-green-700 tw-text-white tw-font-bold tw-px-5 tw-py-2 tw-rounded tw-text-base tw-flex tw-items-center tw-justify-center tw-gap-3">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-5 tw-w-5" viewBox="0 0 20 20" fill="currentColor">
                                                <path fill-rule="evenodd" d="M12.9 14.32a8 8 0 111.414-1.414l4.387 4.387-1.414 1.414-4.387-4.387zM8 14a6 6 0 100-12 6 6 0 000 12z" clip-rule="evenodd" />
                                            </svg>
                                            <span class="tw-font-semibold">Analisar última leitura do {{ selectedSilo && selectedSilo.nome ? selectedSilo.nome : 'silo' }} com foco em {{ form.objetivo }}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="!analiseSelecionada" class="tw-mt-6 tw-grid tw-grid-cols-2 tw-gap-4 tw-max-w-3xl tw-mx-auto">
                        <div :class="theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-white'" class="tw-card-bg tw-rounded tw-p-3 tw-text-sm tw-text-gray-300 tw-flex tw-items-start tw-gap-3">
                            <div class="tw-p-1 tw-icon tw-rounded">
                                <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-5 tw-w-5 tw-text-gray-200" viewBox="0 0 20 20" fill="currentColor">
                                    <path d="M2 11a1 1 0 011-1h2V7a1 1 0 011-1h2V4a1 1 0 011-1h2v2h2a1 1 0 011 1v3h2a1 1 0 011 1v2H2v-2z" />
                                </svg>
                            </div>
                            <div>
                                <div :class="theme === 'dark' ? 'tw-text-gray-500' : 'tw-text-gray-700'" class="tw-font-medium">A IA utilizará dados da ultima leitura</div>
                                <div :class="theme === 'dark' ? 'tw-text-gray-600' : 'tw-text-gray-500'" class="tw-text-xs">A IA utilizará dados de termometria da última leitura para este silo.</div>
                            </div>
                        </div>

                        <div :class="theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-white'" class="tw-card-bg tw-rounded tw-p-3 tw-text-sm tw-text-gray-300 tw-flex tw-items-start tw-gap-3">
                            <div class="tw-p-1 tw-icon tw-rounded">
                                <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-5 tw-w-5 tw-text-gray-200" viewBox="0 0 20 20" fill="currentColor">
                                    <path d="M13 7H7v6h6V7z" />
                                </svg>
                            </div>
                            <div>
                                <div :class="theme === 'dark' ? 'tw-text-gray-500' : 'tw-text-gray-700'" class="tw-font-medium">Recomendações de aeração</div>
                                <div :class="theme === 'dark' ? 'tw-text-gray-600' : 'tw-text-gray-500'" class="tw-text-xs">As recomendações de aeração considerarão as condições climáticas local e o foco definido.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <aside 
            :class="theme === 'dark' ? 'tw-bg-[#0f1114] tw-text-gray-300' : 'tw-bg-white tw-text-gray-700'" 
            class="tw-w-80 tw-h-full tw-flex tw-flex-col tw-border-l tw-border-gray-800/20"
            >
                <div class="tw-p-6 tw-pb-2">
                    <h2 class="tw-text-[10px] tw-font-black tw-tracking-[0.2em] tw-uppercase tw-opacity-60">
                    Análises por local
                    </h2>
                </div>

                <nav class="tw-flex-1 tw-overflow-y-auto tw-px-4 tw-py-2 custom-scrollbar">
                    <ul class="tw-space-y-3">
                    <li v-for="silo in silosFiltered" :key="silo.id" class="tw-group">
                        
                        <button 
                        @click="toggle(silo.id)" 
                        :class="[
                            'tw-w-full tw-flex tw-items-center tw-gap-3 tw-p-3 tw-rounded-xl',
                            expandedId === silo.id 
                            ? (theme === 'dark' ? 'tw-bg-[#1e2024] tw-text-white shadow-lg' : 'tw-bg-gray-100 tw-text-gray-900')
                            : (theme === 'dark' ? 'hover:tw-bg-[#16181d]' : 'hover:tw-bg-gray-50')
                        ]"
                        >
                            <div :class="[
                                'tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center tw-rounded-lg',
                                expandedId === silo.id ? 'tw-bg-[#33b35a]/20 tw-text-[#33b35a]' : 'tw-bg-gray-500/10'
                            ]">
                                <i class="fa-solid fa-database tw-text-sm"></i>
                            </div>

                            <div class="tw-flex-1 tw-text-left tw-overflow-hidden">
                                <p class="tw-text-xs tw-font-bold tw-uppercase tw-truncate">{{ silo.nome }}</p>
                                <p class="tw-text-[10px] tw-opacity-50 tw-font-medium">
                                {{ getAnalisesBySilo(silo.id).length }} Análise{{ getAnalisesBySilo(silo.id).length !== 1 ? 's' : '' }}
                                </p>
                            </div>

                            <i 
                                class="fa-solid fa-chevron-down tw-text-[10px]"
                                :class="{'tw-rotate-180': expandedId === silo.id}"
                            ></i>
                        </button>
                        <ul 
                            v-if="expandedId === silo.id" 
                            class="tw-mt-1 tw-ml-8 tw-border-l tw-border-gray-800/40 tw-pl-4 tw-space-y-1"
                        >
                            <li v-for="analise in getAnalisesBySilo(silo.id)" :key="analise.id">
                            <button 
                                @click="selecionarAnalise(silo, analise)"
                                :class="[
                                'tw-w-full tw-text-left tw-py-3 tw-px-2 tw-rounded-lg group',
                                analiseSelecionada === analise.id 
                                    ? 'tw-text-[#33b35a]' 
                                    : 'hover:tw-bg-white/5'
                                ]"
                            >
                                <div class="tw-flex tw-flex-col">
                                <span class="tw-text-xs tw-font-semibold">
                                    {{ analise.date === 'Invalid Date' ? 'Sem data' : analise.date }}
                                </span>
                                <span class="tw-text-[10px] tw-uppercase tw-opacity-40 tw-font-bold tw-tracking-wider">
                                    {{ analise.objetivo || 'Indefinido' }}
                                </span>
                                </div>
                            </button>
                            </li>
                        </ul>
                    </li>
                    </ul>
                </nav>
            </aside>
        </div>
    </MainLayout>
</template>


<script>
import MainLayout from "@/components/layouts/v2/MainLayout.vue";
import { useToast } from "vue-toastification";
import { mapState } from 'vuex';

export default {
    name: 'WinckieelIntelligence',
    components: {
        MainLayout
    },
    data() {
        return {
            expandedId: null,
            selectedSilo: null,
            analiseSelecionada: null,
            toast: useToast(),
            form: {'objetivo': 'secagem', 'provider': 'gpt'},
            analiseSelecionadaDados: {},
            isLoading: false,
            isDeletingAnalise: false,
            loadingStep: 0,
            polling: null,
            pollingToken: 0,
            pollingAnaliseId: null,
            loadingMessages: [
                "Análise enviada para processamento...",
                "Analise em processamento...",
                "Análise concluída!"
            ],
        };
    },
    computed: {
        ...mapState({
            silos: state => state.silos.silos,
            unidadeState: state => state.unidade.unidade,
            historico: state => state.analiseIa.historicoAnalises,
            theme: state => state.ui.theme,
            isAdmin: state => state.auth.user?.tipo_usuario === 'administrador'
        }),
        statusTermico() {
            const dados = this.analiseSelecionadaDados?.response?.relatorio?.faixa_prod;
            if (!dados) return { texto: 'Indefinido', cor: 'tw-text-gray-400' };
            if (dados.atual > dados.max) return { texto: 'Risco! (Acima)', cor: 'tw-text-red-500' };
            if (dados.atual < dados.min) return { texto: 'Atenção (Abaixo)', cor: 'tw-text-yellow-500' };

            return { texto: 'Seguro', cor: 'tw-text-green-400' };
        },
        unidade() {
            return this.unidadeState || {};
        },
        silosFiltered() {
            if (!this.unidade || !this.unidade.id) return this.silos || [];
            return (this.silos || []).filter(s => String(s.unidade_id) === String(this.unidade.id));
        },
        cabosComDefeito(){
            const lista = this.analiseSelecionadaDados?.response?.relatorio?.cabos_com_defeito;
            if (!lista) return [];
            return lista.filter(item => item.sensores_off && item.sensores_off.length > 0);
        },
        focosDeCalor(){
            const lista = this.analiseSelecionadaDados?.response?.relatorio?.focos_de_calor;
            if (!lista) return [];
            return lista.filter(item => item.sensores_quentes && item.sensores_quentes.length > 0);
        }

    },
    methods: {
        getAnalisesBySilo(siloId) {
            if (!this.historico || !this.historico[siloId]) return [];

            return this.historico[siloId].map(item => ({
                id: item.id,
                date: item.created_at,
                objetivo: item.objetivo
            })).sort((a, b) => b.id - a.id);
        },
        toggle(id) {
            this.expandedId = this.expandedId === id ? null : id;
        },
        async selecionarAnalise(silo, analise) {
            try {
                if (this.analiseSelecionada === analise.id && this.isLoading) {
                    return;
                }
                this.stopPolling();
                const status = await this.$store.dispatch('analiseIa/getAnaliseById', analise.id);

                this.selectedSilo = silo;
                this.analiseSelecionada = analise.id;
                localStorage.setItem('analiseAtual', JSON.stringify({
                    id: analise.id,
                    silo_id: this.selectedSilo.id
                }));
                
                if (status === 2) {
                    this.analiseSelecionadaDados = {};
                    this.analiseSelecionadaDados = this.$store.state.analiseIa.analiseSelecionada;
                    this.isLoading = false;
                } else {
                    this.analiseSelecionadaDados = {};
                    this.$store.commit('analiseIa/SET_ANALISE_SELECIONADA', {});
                    this.startPolling(analise.id);
                }

            } catch (error) {
                this.toast.error("Não foi possível carregar os detalhes da análise.");
                console.error("Erro ao buscar análise por ID:", error);
            }
        },
        async startPolling(analiseId) {
            const currentToken = ++this.pollingToken;
            this.pollingAnaliseId = analiseId;
            this.isLoading = true;
            this.loadingStep = 0;

            let status = 0;
            let tentativas = 0;
            const maxTentativas = 40;

            while (status !== 2 && tentativas < maxTentativas) {
                if (currentToken !== this.pollingToken) return;

                tentativas++;

                const response_status = await this.$store.dispatch("analiseIa/getAnaliseById", analiseId);
                status = response_status;

                this.loadingStep = status;

                if (status === 2) break;
                if (status === 3) {
                    throw new Error("Erro no processamento da análise.");
                }

                await new Promise(resolve => setTimeout(resolve, 2000));
            }

            if (currentToken !== this.pollingToken) return;

            if (status === 2) {
                this.loadingStep = 2;
                await new Promise(resolve => setTimeout(resolve, 300));
                this.analiseSelecionadaDados = this.$store.state.analiseIa.analiseSelecionada;
            } else {
                throw new Error("Tempo limite excedido.");
            }

            this.isLoading = false;
        },
        stopPolling() {
            this.pollingToken++;
            this.pollingAnaliseId = null;
            this.isLoading = false;
        },
        tileClass(name) {
            const base = 'tw-flex-1 tw-p-3 tw-rounded tw-text-sm';
            if (this.form.objetivo === name) {
                return `${base} tw-border-green-600 card-bg tw-ring-1 tw-ring-green-600`;
            }
            return `${base} tw-border-gray-700 card-bg`;
        }
        ,
        async gerarAnalise() {
            if (!this.selectedSilo) {
                this.toast.error("Por favor, selecione um silo.");
                return;
            }
            this.stopPolling();

            try {
                const body = {
                    "silo_id": this.selectedSilo.id,
                    "foco": this.form.objetivo,
                    "ug": this.form.umidade,
                    "provider": this.form.provider
                };

                const response = await this.$store.dispatch("analiseIa/processarAnaliseIa", body);

                if (response.error) {
                    throw new Error(response.message);
                }
                const analiseId = response.analise_id;
                this.expandedId = this.selectedSilo.id;
                this.analiseSelecionada = analiseId;
                localStorage.setItem('analiseAtual', JSON.stringify({
                    id: analiseId,
                    silo_id: this.selectedSilo.id
                }));
                this.analiseSelecionadaDados = null;
                if (this.unidade?.id) {
                    await this.$store.dispatch('analiseIa/getHistoricoAnalises', this.unidade.id);
                }
                this.startPolling(analiseId);
            } catch (error) {
                this.toast.error(error.message || "Ocorreu um erro ao gerar a análise.", 5000);
                console.error("Erro ao gerar análise:", error);
                this.analiseSelecionada = null;
                this.isLoading = false;
                this.loadingStep = 0;
            }
        },
        novaAnaliseForm() {
            this.analiseSelecionada = null;
            this.form.umidade = '';
            this.isLoading = false;
            this.loadingStep = 0;
            this.$store.commit('analiseIa/SET_ANALISE_SELECIONADA', {});
            localStorage.removeItem('analiseAtual');
        },
        async excluirAnaliseSelecionada() {
            if (!this.analiseSelecionada) {
                this.toast.error("Nenhuma análise selecionada para excluir.");
                return;
            }
            localStorage.removeItem('analiseAtual');
            this.analiseSelecionadaDados = null;

            const siloIdSelecionado = this.selectedSilo?.id || this.analiseSelecionadaDados?.silo_id || null;
            this.isDeletingAnalise = true;

            try {
                await this.$store.dispatch('analiseIa/deleteAnaliseById', this.analiseSelecionada);

                if (this.unidade?.id) {
                    await this.$store.dispatch('analiseIa/getHistoricoAnalises', this.unidade.id);
                }

                this.analiseSelecionada = null;

                if (siloIdSelecionado) {
                    this.expandedId = siloIdSelecionado;
                    const siloEncontrado = this.silosFiltered.find(silo => String(silo.id) === String(siloIdSelecionado));
                    this.selectedSilo = siloEncontrado || null;
                }

                this.toast.success("Análise excluída com sucesso.");
            } catch (error) {
                this.toast.error("Não foi possível excluir a análise.");
                console.error("Erro ao excluir análise:", error);
            } finally {
                this.isDeletingAnalise = false;
            }
        }
    }
    ,
mounted() {
        const saved = localStorage.getItem('analiseAtual');

        if (saved) {
            const { id, silo_id } = JSON.parse(saved);

            this.analiseSelecionada = id;

            const silo = this.silosFiltered.find(s => String(s.id) === String(silo_id));
            if (silo) {
                this.selectedSilo = silo;
                this.expandedId = silo.id;
            }

            this.startPolling(id);
        }
        const unidadeId = this.unidade && this.unidade.id ? this.unidade.id : (this.$route && this.$route.params && this.$route.params.unidade);
        if (unidadeId) {
            this.$store.dispatch('silos/fetchSilosByUnidade', unidadeId).catch(() => {});
            this.$store.dispatch('analiseIa/getHistoricoAnalises', unidadeId).catch(() => {});
        }
        const analise = this.$store.state.analiseIa.analiseSelecionada;

        if (analise && analise.id) {
            this.analiseSelecionada = analise.id;

            const silo = this.silosFiltered.find(s => String(s.nome) === String(analise.silo_descricao));
            if (silo) {
                this.selectedSilo = silo;
                this.expandedId = silo.id;
            }

            if (analise.status !== 2) {
                this.isLoading = true;
                this.loadingStep = analise.status || 0;
                this.analiseSelecionadaDados = null;

                this.startPolling(analise.id);
            } else {
                this.analiseSelecionadaDados = analise;
                this.isLoading = false;
            }
        }
    },
    watch: {
        unidade(newVal) {
            if (newVal && newVal.id) {
                this.$store.dispatch('silos/fetchSilosByUnidade', newVal.id).catch(() => {});
            }
        }
    }
};
</script>

<style scoped>
.container { max-width: 1100px; }
.card-bg {
    background-color: rgba(39,43,47,0.35);
    border: 1px dotted rgba(255,255,255,0.06);
}
.card-bg:hover { background-color: rgba(39,43,47,0.42); }
.card-bg .icon { background-color: rgba(255,255,255,0.02); }

.tw-history-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem 0.5rem;
    border-radius: 0.5rem;
    background: transparent;
    border-left: 3px solid transparent;
    width: 100%;
}
.tw-history-item:hover {
    background-color: rgba(0,0,0,0.19);
}
.tw-history-active {
    background-color: rgba(0,0,0,0.19);
}
.tw-history-left .tw-history-date { font-size: 0.72rem; color: rgba(255,255,255,0.45); }
.tw-history-left .tw-history-title { font-size: 0.92rem; font-weight: 400; color: rgba(255,255,255,0.9); }
.tw-history-right { display:flex; align-items:center; gap:0.5rem; }
.tw-history-tag { font-size:0.7rem; padding:0.15rem 0.5rem; border-radius:0.4rem; border:1px dotted rgba(255,255,255,0.06); color:rgba(255,255,255,0.8); }
.tw-history-chevron { color: rgba(255,255,255,0.5); }

ul::-webkit-scrollbar {
    width: 4px;
}
ul::-webkit-scrollbar-thumb {
    background: rgba(255,255,255,0.2);
    border-radius: 4px;
}
nav::-webkit-scrollbar {
    width: 4px;
}
nav::-webkit-scrollbar-thumb {
    background: rgba(255,255,255,0.2);
    border-radius: 4px;
}
.tw-custom-select {
    appearance: none;
    background-color: rgba(39,43,47,0.35);
    color: rgba(255,255,255,0.9);
    padding: 0.5rem 2.5rem 0.5rem 0.75rem;
    border-radius: 0.5rem;
    width: 100%;
    font-size: 0.9rem;
}

.tw-custom-select:hover {
    background-color: rgba(39,43,47,0.45);
}

.tw-custom-select:focus {
    outline: none;
    background-color: rgba(39,43,47,0.55);
}

.tw-custom-input {
    background-color: rgba(39,43,47,0.35);
    color: rgba(255,255,255,0.9);
    padding: 0.5rem 0.75rem;
    font-size: 0.9rem;
}

.tw-custom-input:hover {
    background-color: rgba(39,43,47,0.45);
    border-color: rgba(255,255,255,0.15);
}

.tw-custom-input:focus {
    outline: none;
    background-color: rgba(39,43,47,0.55);
}

.tw-input-addon {
    color: rgba(255,255,255,0.7);
    padding: 0.5rem 0.75rem;
    border-radius: 0 0.5rem 0.5rem 0;
    font-size: 0.85rem;
}

[data-theme="light"] .card-bg {
    background-color: rgba(131, 131, 131, 0.185) !important;
    color: #1f2937 !important;
}

[data-theme="light"] .tw-history-item { color: #374151 !important; }
[data-theme="light"] .tw-history-item:hover, [data-theme="light"] .tw-history-active {
    background-color: rgba(0, 0, 0, 0.05) !important;
}
[data-theme="light"] .tw-history-left .tw-history-date { color: #6b7280 !important; }
[data-theme="light"] .tw-history-left .tw-history-title { color: #1f2937 !important; }
[data-theme="light"] .tw-history-tag { color: #575757 !important; border-color: rgba(0, 0, 0, 0.363) !important; }
[data-theme="light"] .tw-history-chevron { color: #9ca3af !important; }

[data-theme="light"] .tw-custom-select, [data-theme="light"] .tw-custom-input {
    background-color: rgba(131, 131, 131, 0.185);
    color: #1f2937;
}
[data-theme="light"] .tw-custom-select:focus, [data-theme="light"] .tw-custom-input:focus {
    background-color: #f9fafb;
    border-color: #3b82f6;
}
[data-theme="light"] .tw-input-addon {
    color: #4b5563;
    border-left: none;
}
[data-theme="light"] .tw-bg-\[\#1a1d21\] { background-color: #ffffff !important; }
[data-theme="light"] .tw-text-gray-100 { color: #111827 !important; }
[data-theme="light"] .tw-text-gray-200 { color: #1f2937 !important; }
[data-theme="light"] .tw-text-gray-300 { color: #374151 !important; }
[data-theme="light"] .tw-text-gray-400 { color: #4b5563 !important; }
[data-theme="light"] .tw-text-gray-500 { color: #6b7280 !important; }
[data-theme="light"] .tw-text-gray-600 { color: #6b7280 !important; }
[data-theme="light"] .tw-bg-gray-800 { background-color: #e5e7eb !important; color: #1f2937 !important; }
[data-theme="light"] .tw-bg-black\/20 { background-color: #f3f4f6 !important; }
[data-theme="light"] .tw-bg-black\/10 { background-color: #ebe9e9 !important; }
[data-theme="light"] .tw-bg-gray-700 { background-color: #d1d5db !important; }
</style>
